import store from "@/store";

export const mixinChat = {
    data: () => ({
      userType: 'dms-user',
      sendType: {
        SEND_FAIL: 'SEND_FAIL',             // 전송 실패
        JOIN: 'JOIN',                       // 입장
        EXIT: 'EXIT',                       // 퇴장
        SEND: 'SEND',                       // 발신
        RECEIVE: 'RECEIVE',                 // 전체수신
        DELETED: 'DELETED',                 // 메세지 삭제
        TYPING: 'TYPING',                   // 작성중
        UNTYPING: 'UNTYPING',               // 작성중 아님
        OPEN: 'OPEN',                       // 채팅상담 시작
        CLOSE: 'CLOSE'                      // 채팅상담 종료
      },
      messageTypeCode: {
        TEXT: 'TEXT',                       // 일반텍스트
        LINK: 'LINK',                       // 링크형
        NA: 'NA'                            // 해당없음
      },
      // currentDateTime: Util.Date.getToday('YYYYMMDDHHmmss'),
      remainTimeInterval: null,
      counter: 0,
      isPlusTime: false,
      formDisabled: true
    }),
    methods: {
        makeMessageTarget(userType) {
          return userType == 'dms-user' ? 'me' : 'you'
        },
        makeMessageStyle(userType) {
          return userType == 'dms-user' ? ['chat', 'me'] : ['chat', 'you']
        },
        formattedLink(text) {
          let formattedLinkText = []
          const regex = /(https?:\/\/[^\s]+)/g;
          let startIndex = 0;
          let result;
          while ((result = regex.exec(text)) !== null) {
            const link = result[0];
            const index = result.index;
            if (index > startIndex) {
              formattedLinkText.push({
                isLink: false,
                content: text.substring(startIndex, index)
              });
            }
            formattedLinkText.push({
              isLink: true,
              content: link
            });
            startIndex = index + link.length;
          }
          if (startIndex < text.length) {
            formattedLinkText.push({
              isLink: false,
              content: text.substring(startIndex)
            });
          }
          return formattedLinkText
        },
        pushMessage (body) {
          if (this.messages.length && (this.messages[this.messages.length - 1].sendType === this.sendType.TYPING)) {
              this.messages.splice(this.messages.length - 1, 0, body)
          } else {
              this.messages.push(body)
          }
        },
        createMessage(textMessage, messageTypeCode, sendType) {
          return {
            content: textMessage,
            roomId: this.roomId,
            senderId: this.$store.state.auth.authUser.userKey,
            bookmark: false,
            userType: 'dms-user',
            messageTypeCode: messageTypeCode,
            sendType: (sendType === undefined || sendType === '') ? 'SEND' : sendType
          }
        },
        exit() {
          window.close()
        },
        clearTyping(userType) {
          if (userType) {
            let index = this.messages.findIndex(x => x.sendType === this.sendType.TYPING && x.userType === userType)
            if (index !== -1) {
              this.messages.splice(index, 1)
            }
          } else {
            this.messages.forEach((x, i) => {
              if (x.sendType === this.sendType.TYPING) {
                this.messages.splice(i, 1)
              }
            })
          }
        },
        deleteMessage(body) {
          let index = this.messages.findIndex(x => x.id === body.id)
          if (index !== -1) {
            this.messages.splice(index, 1)
            this.messages.forEach((x, i) => {
               if (x.sendType === this.sendType.TYPING) {
                 this.messages.splice(i, 1)
               }
             })
            // 삭제 메시지 보여주고 싶으면 deleted 값만 true로 바꿔줌
            // this.messages[index].deleted = true
          }
        },
        async getGuideFeedbackResultMap(message) {
            const {id, feedbackType, travelApplNo, travelApplStepCd, memberStepApplCnt, unitFdbNo} = message
            let feedback;
            let unitUseNo;
            // 여행지원서 피드백
            if (feedbackType === "travel") {
              await store.dispatch('getMemberApplResultFdb', this.$_payload('so', [{travelApplNo}, {travelApplStepCd}, {memberStepApplCnt}]))
                  .then(res => {
                    feedback = res.data.fdb
                  })
                  .catch(error => {
                    console.error(error)
                  })
                  .finally(() => {})
            }
            // 유닛 피드백
            else {
              if (unitFdbNo) {
                await store.dispatch('getUnitFdb', this.$_payload('so', [{unitFdbNo}]))
                    .then(res => {
                        unitUseNo = res.data.sltUnitMappingUseNo
                        feedback = res.data.fdb
                     })
                    .catch(error => {
                      console.error(error)
                    })
                    .finally(() => {})
              }
            }
            return {
                feedbackType, travelApplNo, travelApplStepCd, memberStepApplCnt, unitFdbNo,
                unitUseNo, id, feedback: feedback || ""
            };
        },
        handleMessageFocus(id) {
            window.location.href = '#' + id;
        },
        //피드백 화면 전환 후 메세지 이동
        handleMessageFocusByCurrentURL() {
            const regex = /#([^#]+)#feedback/;
            const matchResult = window.location.href.match(regex);
            if (matchResult) {
              // eslint-disable-next-line no-unused-vars
              const [all, match] = matchResult;
              this.handleMessageFocus(match);
            }
        },
        async saveBookmark(params) {
          await store.dispatch('saveBookmark', this.$_payload('message', {
              id: params.id, roomId :params.roomId, bookmark: params.bookmark
          }))
              .then(res => {
                if (!res.success) {
                    this.$alert(res.msg)
                }
                // if (!res.success || params.bookmark) {
                //     this.$root.$children[0].$refs.toast.toastOpen('top', res.msg);
                // }
              })
              .catch(error => {
                console.error(error)
              })
              .finally(() => {
              })
        },
    }
}

